export const emailInfo = {
    "contact":{
        "senderAddress":"info@innovationstechnologique.com",
        "recipients":"info@innovationstechnologique.com"
    },
    "post":{
        "senderAddress":"Hr.itsc@innovationstechnologique.com",
        "recipients":"Hr.itsc@innovationstechnologique.com"
    }
}